import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Card, List, Popover, Popconfirm, Typography } from 'antd'
import { Check, Edit, X } from 'react-feather'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { DisabledTypes } from 'Model'
import { setDisabledTypes } from 'Actions/explore'
import { NodePicker } from 'Components'
import { getMemberKey, getMemberKeys, getNodeLabel, getUid } from 'Services/WeaverUtils'
import { showGenericErr } from './helpers'
import Feather from '@sysunite/react-feather'
import ColorService from 'Services/ColorService'
import WeaverService from 'Services/WeaverService'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph style={{ width: 500, lineHeight: '1.6rem' }}>
    <Text code>disabledTypes</Text> are used to determine which <Text mark>types</Text> to ignore within a project.
    Multiple <Text code>disabledTypes</Text> can be configured.
  </Paragraph>
</div>)

info = (
  <Popover
    content={helpText}
    title='Disabled Types'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

DisabledTypesPanel = ({ disabledTypes, setDisabledTypes }) ->

  [isEditing, setIsEditing] = useState(false)
  [loading, setLoading] = useState(true)
  [configNode, setConfigNode] = useState(undefined)
  [disabledTypeNodes, setDisabledTypeNodes] = useState([])
  [typeIdsToDisable, setTypeIdsToDisable] = useState([])

  useEffect( ->
    ( ->
      setConfigNode(await DisabledTypes.load())
      await updateList(disabledTypes)
      setLoading(false)
    )()
    undefined
  , [])

  updateList = (ids) ->
    nodes = await new Weaver.Query().restrict(ids).find()
    setDisabledTypeNodes(nodes)

  remove = (item) ->
    filteredNodesArr = disabledTypeNodes.filter((_item) -> _item.id() isnt item.id())
    filteredIdsArr = _.map(filteredNodesArr, (node) -> node.id())
    try
      await configNode.update(filteredIdsArr)
      setDisabledTypes(filteredIdsArr)
      updateList(filteredNodesArr)
    catch
      showGenericErr()

  save = ->
    existingDisabledTypeIds = _.map(disabledTypeNodes, ({ nodeId }) -> nodeId)
    updatedDisabledTypesIds = _.union(typeIdsToDisable, existingDisabledTypeIds)
    try
      await configNode.update(updatedDisabledTypesIds)
      setDisabledTypes(updatedDisabledTypesIds)
      await updateList(updatedDisabledTypesIds)
    catch
      showGenericErr()
    setIsEditing(false)

  saveCancelActionButtons = [
    <Button
      type="text"
      onClick={ -> save() }
    >
      <Check />
    </Button>
    <Button
      type="text"
      onClick={ -> setIsEditing(false)}
    >
      <X />
    </Button>
  ]

  editActionButton = [
    <Button
      type="text"
      disabled={!WeaverService.userCanEdit()}
      onClick={ -> setIsEditing(true)}
    >
      <Edit />
    </Button>
  ]

  renderListItem = (type) ->
    color = ColorService.getColorForType(type.id())
    label = getNodeLabel(type)
    <span>
      <Feather width="1em" height="1em" type="circle" style={{ marginRight: '3px', fill: color, color }} />
      { if label is '[ blank ]' then getUid(type) else label }
    </span>

  actions = ( if isEditing then saveCancelActionButtons else editActionButton )

  <Card
    title="Disabled Types"
    loading={loading}
    actions={actions}
    extra={info}
    size="small"
    id="Disabled types"
  >
    <List
      dataSource={disabledTypeNodes}
      renderItem={(type) ->
        uid = getUid(type)
        label = getNodeLabel(type)
        (
          <List.Item
            actions={
              [
                <Popconfirm
                  placement="topLeft"
                  title="Are you sure you want to remove #{ if label isnt '[ blank ]' then label else uid } from disabled types?"
                  onConfirm={ -> remove(type)}
                  okText="Yes"
                  cancelText="No"
                >
                  <a key="disabled-type-delete-#{uid}">delete</a>
                </Popconfirm>
              ]
            }
          >
            <div>{renderListItem(type)}</div>
          </List.Item>
        )
      }
    />
    {
      if isEditing
        <NodePicker
          mode="multiple"
          placeholder="Select a type to disable"
          query={new Weaver.Query().hasRelationIn(getMemberKeys())}
          onSelect={setTypeIdsToDisable}
          style={{ width: '100%' }}
        />
    }
  </Card>

export default connect(({ explore }) ->
  { disabledTypes: explore.disabledTypes }
, { setDisabledTypes })(DisabledTypesPanel)
